import type { CascaderOption } from './types';

/**
 * オプションツリーに対してdisabledItemValuesを適用する
 */
export const applyDisabledValues = (
  options: CascaderOption[],
  disabledItemValues: string[],
  disabledItemReasons?: Record<string, string>,
): CascaderOption[] => {
  return options.map((option) => {
    const isDisabled = disabledItemValues.includes(option.value);
    const reason = disabledItemReasons?.[option.value];
    return {
      ...option,
      disabled: option.disabled || isDisabled,
      disabledReason: option.disabledReason || (isDisabled ? reason : undefined),
      children: option.children
        ? applyDisabledValues(option.children, disabledItemValues, disabledItemReasons)
        : [],
    };
  });
};
